<template>
  <div class="">
    <ContainerLayout :isOverview="isOverview">
      <template v-slot:contentPart>
        <component :is="dynamicComponent.content"/>
      </template>
      <template v-slot:contextActionPanel>
        <ActionPanel :actions="actionsForPanel">
          <template v-slot:extraButtons >
              <ExportOrderList v-if="getSelectedResourceID.objectID !== null" />
              <OrdersQuoting
                v-if="getTransportResourceDetails != null"
                :transport="getTransportResourceDetails"
              />
            </template>
        </ActionPanel>
      </template>
      <template v-slot:contextPart>
        <component :is="dynamicComponent.context"/>
      </template>
      <template v-slot:contextFooter>
        <ContextFooterRM/>
      </template>
    </ContainerLayout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ContainerLayout from '@/components/wrld/generic/ContainerLayout'
import ActionPanel from '@/components/wrld/generic/ActionPanel'
import ContextFooterRM from '@/components/wrld/generic/ContextFooterRM'
import OrdersOverviewContent from '@/components/orders/new/OrdersOverviewContent.vue'
import OrdersOverviewContext from '@/components/orders/new/OrdersOverviewContext.vue'
import ExportOrderList from '@/components/orders/new/ExportOrderList.vue'
import OrdersQuoting from '@/components/orders/new/OrdersQuoting.vue'
export default {
  name: 'OrdersNew',
  components: {
    ContainerLayout,
    ActionPanel,
    ContextFooterRM,
    OrdersOverviewContent,
    OrdersOverviewContext,
    ExportOrderList,
    OrdersQuoting
  },
  props: {
    selectedView: String
  },
  data () {
    return {}
  },
  methods: {
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getTransportResourceDetails',
      'getSelectedResourceID'
    ]),
    isOverview () {
      return this.selectedView === 'overview'
    },
    actionsForPanel () {
      let panelActions = []
      let show = {
        back: false,
        detail: false,
        transport_request: false
      }
      // switch (this.selectedView) {
      //   case 'overview':
      //     if (this.getSelectedResourceID.objectID !== null) {
      //       show.detail = true
      //       show.transport_request = true
      //     }
      //     break
      //   case 'detail':
      //     show.back = true
      //     show.transport_request = true
      //     break
      //   case 'transport_request':
      //     show.back = true
      //     show.detail = true
      //     break
      //   default: // default is overview
      //     if (this.getSelectedResourceID.objectID !== null) {
      //       show.detail = true
      //       show.transport_request = true
      //     }
      //     break
      // }
      if (show.back === true) {
        panelActions.push({
          icon: 'fas fa-arrow-circle-left',
          name: 'Back', // TODO: add to i18n
          callback: this.goToOverview
        })
      }
      if (show.detail === true) {
        panelActions.push({
          icon: 'fas fa-info-circle',
          name: 'Order detail', // TODO: add to i18n
          callback: this.goToDetail
        })
      }
      if (show.transport_request === true) {
        panelActions.push({
          icon: 'fas fa-dolly-flatbed',
          name: 'Transport Request', // TODO: add to i18n
          callback: this.goToFleet
        })
      }
      return panelActions
    },
    dynamicComponent () {
      switch (this.selectedView) {
        case 'overview':
          return {
            content: 'OrdersOverviewContent',
            context: 'OrdersOverviewContext'
          }
        case 'detail':
          return {
            content: 'OrganizationsDetailContent',
            context: 'OrganizationsOverviewContext'
          }
        case 'fleet':
          return {
            content: 'FleetOverviewContent',
            context: 'FleetOverviewContext'
          }
        case 'locations':
          return {
            content: 'LocationsOverviewContent',
            context: 'LocationsOverviewContext'
          }
        default: // default is overview
          return {
            content: 'OrganizationsOverviewContent',
            context: 'OrganizationsOverviewContext'
          }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
